import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';
import 'rxjs/add/observable/throw';

import { BaseWebService } from "./base-web.service";
import { SessionStorageService } from "./session-storage.service"

import { config } from "../../../../config/index";

@Injectable()
export class ChangePasswordService {

    passwordDetails: any = {};
    key: any = "confirm_password";
    private _STORAGE_KEY = config.storage_key;
    private _role = config.role;
    private _menuList = config.menu_list;

    constructor(
        private _basewebservice: BaseWebService,
        private _sessionStorageService: SessionStorageService
    ) { }

    saveToken = async (key: string, data: any) => {
        try {
            if (key === "storage_key") {
                await this._sessionStorageService.saveItem(this._STORAGE_KEY, data);
            }
            else if (key === "role") {
                await this._sessionStorageService.saveItem(this._role, data);
            }
            else if (key === "menu_list") {
                await this._sessionStorageService.saveItem(this._menuList, data);
            }
        }
        catch (error) {
            return error;
        }
    }

    /**
     * Service for get change password
     */
    changePassword(data: any) {

        this.passwordDetails.body = data;
        return this._basewebservice.request("v1/change_password/", "patch", this.passwordDetails)
            .map(res => res)
            .catch(this.handleError);
    }

    /* Service for handling service call errors
     * @param  {Response|any} error contains error data
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}

